import React, { useRef, useEffect, useState } from 'react';
import {getDebugTrace} from '../PyTutorService';
import DataViz from "../component/pytutor/DataViz";
import {getTraceLayouts} from "../util/TraceUtil";
import StepCtrl from "../component/pytutor/StepCtrl";

export default () => {
  const [dat, setDat] = useState();
  const [curEntry, setCurEntry] = useState();
  const [curTraceLayout, setCurTraceLayout] = useState();
  const [curInstr, setCurInstr] = useState(0);
  const [traceLayouts, setTraceLayouts] = useState([]);
  const code = `
class ListNode:
    def __init__(self, val=0, next=None):
        self.val = val
        self.next = next


def addTwoNumbers(l1, l2):
    dummy = ListNode(0)
    current = dummy
    carry = 0

    while l1 or l2 or carry:
        # 获取当前两个链表节点的值
        val1 = l1.val if l1 else 0
        val2 = l2.val if l2 else 0

        # 计算当前位的和及进位
        sum_val = val1 + val2 + carry
        carry = sum_val // 10
        current.next = ListNode(sum_val % 10)

        # 移动到下一个节点
        current = current.next
        l1 = l1.next if l1 else None
        l2 = l2.next if l2 else None

    return dummy.next


# 辅助函数：将列表转换成链表
def list_to_linked_list(lst):
    dummy = ListNode(0)
    current = dummy
    for value in lst:
        current.next = ListNode(value)
        current = current.next
    return dummy.next


# 辅助函数：将链表转换成列表（方便打印和验证结果）
def linked_list_to_list(node):
    result = []
    while node:
        result.append(node.val)
        node = node.next
    return result


# 测试代码
if __name__ == "__main__":
    # 测试用例 1
    l1 = list_to_linked_list([2, 4, 3])  # 表示数字 342
    l2 = list_to_linked_list([5, 6, 4])  # 表示数字 465
    result = addTwoNumbers(l1, l2)       # 结果应该是 [7, 0, 8] (807)
    print(linked_list_to_list(result))   # 输出: [7, 0, 8]

    # 测试用例 2
    l1 = list_to_linked_list([0])        # 表示数字 0
    l2 = list_to_linked_list([0])        # 表示数字 0
    result = addTwoNumbers(l1, l2)       # 结果应该是 [0]
    print(linked_list_to_list(result))   # 输出: [0]

    # 测试用例 3
    l1 = list_to_linked_list([9, 9, 9, 9, 9, 9, 9])  # 表示 9999999
    l2 = list_to_linked_list([9, 9, 9, 9])           # 表示 9999
    result = addTwoNumbers(l1, l2)                   # 结果应该是 [8, 9, 9, 9, 0, 0, 0, 1] (10009998)
    print(linked_list_to_list(result))               # 输出: [8, 9, 9, 9, 0, 0, 0, 1]

  `
  useEffect(() => {
    dat || getDebugTrace(code).then((dat) => {
      console.log("useEffect getDebugTrace")
      console.log(dat)
      console.log(2)
      setDat(dat)
      let traceLayouts = getTraceLayouts(dat.trace);
      setTraceLayouts(traceLayouts)
      setCurEntry(dat.trace[curInstr])
      setCurTraceLayout(traceLayouts[curInstr])
    })
  }, []);
  useEffect(() => {
    console.log("curInstr changed")
    if (dat) {
      setCurEntry(dat.trace[curInstr])
      setCurTraceLayout(traceLayouts[curInstr])
    }
  }, [curInstr]);
  if (curEntry && curTraceLayout){
    return (
      <div className="ExecutionVisualizer">
        <table border="0" className="visualizer">
          <tbody>
          <tr>
            <td className="vizLayoutTd" id="vizLayoutTdFirst">
              <div id="codAndNav" className="ui-resizable" style={{width: "500px"}}>
                <StepCtrl curInstr={curInstr} setCurInstr={setCurInstr} total={dat.trace.length}/>
              </div>
            </td>
            <td className="vizLayoutTd" id="vizLayoutTdSecond">
              <DataViz curEntry={curEntry} curTraceLayout={curTraceLayout}/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    );
  } else {
    return <></>
  }

};
